import { Fragment, memo } from 'react'
import { ICellRendererParams } from 'ag-grid-community'
import { useTranslations } from 'next-intl'
import { Badge } from '@skop-app/lib-front'

import type { Property } from '@/services/property'

export const PropertyCellRenderer = memo(
  (props: ICellRendererParams<Property>) => {
    const { value } = props
    const t = useTranslations('Property')
    return (
      <Fragment>
        <Badge variant="outline">{t(value)}</Badge>
      </Fragment>
    )
  },
)

PropertyCellRenderer.displayName = 'PropertyCellRenderer'
